import { Tooltip } from "antd";
import NormalToolTip from "../../../../base/basicComponents/toolTip";
import StatusDiv from "../../../../base/basicComponents/status/index";
import { GetColumnCheckboxGroupFilterDropdown } from "../../../commonComponents/listTable/CustomFilter";
import ListEditBtnIcon from "../../../../base/basicComponents/listEditBtnIcon";
import shareProcedureDetailEntry from "../../../../assets/image/share.svg";
import editProcedureDetailDisable from "../../../../assets/image/updateDisable.png";
import downloadProcedureDetailEntry from "../../../../assets/image/download.svg";
import changeHistoryEntry from "../../../../assets/image/changeHistory.svg";
import ListColumnBase from ".//listColumnBase";
import PMPExcludedEditField from "./pmpExcludeEditField";
import styles from "../index.module.scss";

import { openSections, userRoles } from "../../../publicDictionaryValues";
import "./index.scss";
import {
  GetProcedureListFilterNewResponseType,
  GetProcedureListNewResponseType,
} from "service/procedureList/types";
import { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";
import { FilterDropdownProps } from "antd/lib/table/interface";
import { convertedTasks } from "../utils";
import AppSetting from "config/AppSetting";
import ListUpdateBtnIcon from "base/basicComponents/listUpdateBtnIcon/index";
import { AssignPPOSelect } from "./assignPPO";

const user = AppSetting.localStorageValue.user.get();
const loginUserRoles: { projectID: string; roleID: string }[] = user?.roles || [];
const asAndAboveRolesSet = new Set([
  userRoles.Manager,
  userRoles.Assistant,
  userRoles.TeamLeader,
  userRoles.Specialist,
]);

const formatAndCheckDate = (input: string | null | undefined): string => {
  if (!input) return "";

  const date = dayjs(input);
  return date.isValid() ? date.format("MM/DD/YYYY") : "";
};

const createFilterDropdown =
  (filterLoading: boolean) =>
  ({ setSelectedKeys, selectedKeys, confirm, clearFilters, filters }: FilterDropdownProps) =>
    GetColumnCheckboxGroupFilterDropdown({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      filters,
      filterLoading,
    });

const mapStatus = (status: string) => {
  let statusId;
  switch (status) {
    case "Active":
      statusId = 3;
      break;
    case "Pending Approval":
      statusId = 2;
      break;
    case "Draft":
      statusId = 1;
      break;
    case "Archived":
      statusId = 4;
      break;
    case "Updating":
      statusId = 7;
      break;
    default:
      statusId = 0;
      break;
  }

  return statusId;
};

/**
 * function about control pmp excluded edit icon show and hide
 * @param {object} record row data
 */
const controlPmpExcludedEditShow = (record: ReturnType<typeof convertedTasks>[number]) => {
  const loginUserRoles = AppSetting.localStorageValue.user.get()?.roles as {
    projectID: string;
    roleID: string;
  }[];

  const recordRoles: string[] = [];
  loginUserRoles.forEach((item) => {
    if (item.projectID === record.procedureAccountID) {
      recordRoles.push(item.roleID);
    }
  });
  const rolesList = [
    userRoles.Manager,
    userRoles.Opex,
    userRoles.Specialist,
    userRoles.TeamLeader,
    userRoles.Assistant,
  ];
  return (
    recordRoles.findIndex(
      (roleItem) =>
        (rolesList.findIndex((item) => item === roleItem) !== -1 && record.pmpExcluded === "Yes") ||
        (roleItem === userRoles.AccountMember && record.pmpExcluded === "No")
    ) !== -1
  );
};

// generate procedure list table columns
export default function ProcedureListListColumn({
  tableFilterDataNew,
  filteredInfo,
  columnsVisible,
  handleSubmitPPO,
  setProcedureListData,
  procedureListData,
  tableSortData,
  handleDownloadClick,
  handleShareClick,
  filterLoading,
  onFilterDropdownOpenChange,
  setLoading,
  refreshProcedureList,
}: {
  tableFilterDataNew: GetProcedureListFilterNewResponseType;
  filteredInfo: Record<string, string[] | number[] | null>;
  columnsVisible: Record<string, boolean>;
  tableSortData: {
    sortColumn: string;
    isAscending: boolean;
  }[];
  handleSubmitPPO: (
    para: {
      primaryProcedureOwnerId: string;
      procedureTaskId: string;
    },
    submitSuccess: (res: any) => void,
    submitFaild: (error: string) => void
  ) => any;
  setProcedureListData: (list: GetProcedureListNewResponseType["newData"]) => void;
  procedureListData: GetProcedureListNewResponseType["newData"];
  handleDownloadClick: (record: ReturnType<typeof convertedTasks>[number]) => void;
  handleShareClick: (record: ReturnType<typeof convertedTasks>[number]) => void;
  filterLoading: boolean;
  onFilterDropdownOpenChange: (open: boolean) => void;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  refreshProcedureList: () => void;
}) {
  const { mapFilter, handleWidth, handleTableSortOrder, convertedFilter } = ListColumnBase();
  const filterDropdown = createFilterDropdown(filterLoading);

  const columns: ColumnsType<ReturnType<typeof convertedTasks>[number]> = [
    {
      title: "Client Abbreviation",
      dataIndex: "clientAbbr",
      //dbName is sort key value, what we can do?
      //@ts-ignore
      dbName: "ClientAbbr",
      sorter: true,
      sortOrder: handleTableSortOrder("ClientAbbr", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (clientAbbr) => (
        <Tooltip placement="topLeft" title={clientAbbr}>
          {clientAbbr}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.clientAbbrShow, 180),
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      ellipsis: {
        showTitle: false,
      },
      render: (clientName) => (
        <Tooltip placement="topLeft" title={clientName}>
          {clientName}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.clientNameShow, 220),
    },
    {
      title: "Account Code",
      dataIndex: "accountAbbr",
      //@ts-ignore
      dbName: "AccountAbbr",
      sorter: true,
      sortOrder: handleTableSortOrder("AccountAbbr", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (accountAbbr) => (
        <Tooltip placement="topLeft" title={accountAbbr}>
          {accountAbbr}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.accountAbbrShow, 145),
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      ellipsis: {
        showTitle: false,
      },
      render: (accountName) => (
        <Tooltip placement="topLeft" title={accountName}>
          {accountName}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.accountNameShow, 220),
    },
    {
      title: "Account Manager",
      dataIndex: "accountManager",
      filters: mapFilter(tableFilterDataNew.accountManagers),
      filteredValue: filteredInfo.accountManager || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (accountManager) => (
        <Tooltip placement="topLeft" title={accountManager}>
          {accountManager}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.accountManagerShow, 170),
    },
    {
      title: "Account Supervisor",
      dataIndex: "accountSupervisor",
      filters: mapFilter(tableFilterDataNew.accountSupervisors),
      filteredValue: filteredInfo.accountSupervisor || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (accountSupervisor) => (
        <Tooltip placement="topLeft" title={accountSupervisor}>
          {accountSupervisor}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.accountSupervisorShow, 180),
    },
    {
      title: "Team Leader",
      dataIndex: "accountTeamLeader",
      filters: mapFilter(tableFilterDataNew.accountTeamLeaders),
      filteredValue: filteredInfo.accountTeamLeader || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (accountTeamLeader) => (
        <Tooltip placement="topLeft" title={accountTeamLeader}>
          {accountTeamLeader}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.accountTeamLeaderShow, 140),
    },
    {
      title: "Task Status",
      dataIndex: "taskStatus",
      //@ts-ignore
      dbName: "TaskStatusName",
      sorter: true,
      sortOrder: handleTableSortOrder("TaskStatusName", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (taskStatus) => (
        <Tooltip placement="topLeft" title={taskStatus}>
          {taskStatus}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.taskStatusShow, 135),
    },
    {
      title: "Task Group",
      dataIndex: "taskGroupName",
      //@ts-ignore
      dbName: "TaskGroupName",
      sorter: true,
      sortOrder: handleTableSortOrder("TaskGroupName", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (taskGroupName) => (
        <Tooltip placement="topLeft" title={taskGroupName}>
          {taskGroupName}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.taskGroupNameShow, 220),
    },
    {
      title: "Category",
      dataIndex: "categoryName",
      //@ts-ignore
      dbName: "Path",
      sorter: true,
      sortOrder: handleTableSortOrder("Path", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (categoryName) => (
        <Tooltip placement="topLeft" title={categoryName}>
          {categoryName}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.categoryNameShow, 220),
    },
    {
      title: "Task Label Name",
      dataIndex: "taskLabelName",
      //@ts-ignore
      dbName: "TaskLabelName",
      sorter: true,
      sortOrder: handleTableSortOrder("TaskLabelName", tableSortData),
      filters: mapFilter(tableFilterDataNew.taskLabelNames.map((i) => ({ id: i, name: i }))),
      filteredValue: filteredInfo.taskLabelName || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (taskLabelName) => (
        <Tooltip placement="topLeft" title={taskLabelName}>
          {taskLabelName}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.taskLabelNameShow, 220),
    },
    {
      title: "Task ID",
      dataIndex: "taskId",
      filters: mapFilter(tableFilterDataNew.taskIds.map((i) => ({ id: i, name: i }))),
      filteredValue: filteredInfo.taskId || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (taskId) => (
        <Tooltip placement="topLeft" title={taskId}>
          {taskId}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.taskIdShow, 105),
    },
    {
      title: "Procedure Folder Status",
      dataIndex: "procedureFolderStatus",
      filters: mapFilter(tableFilterDataNew.procedureFolderStatus),
      filteredValue: filteredInfo.procedureFolderStatus || null,
      onFilterDropdownOpenChange,
      ellipsis: {
        showTitle: false,
      },
      filterDropdown,
      render: (text) => (
        <Tooltip placement="topLeft" title={mapStatus(text)}>
          <StatusDiv status={mapStatus(text)}></StatusDiv>
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.procedureFolderStatusShow, 220),
    },
    {
      title: "Task Created Date",
      dataIndex: "taskCreatedTime",
      //@ts-ignore
      dbName: "TaskCreatedDate",
      sorter: true,
      sortOrder: handleTableSortOrder("TaskCreatedDate", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (taskCreatedTime) => {
        const formatDate = formatAndCheckDate(taskCreatedTime);
        return (
          <Tooltip placement="topLeft" title={formatDate}>
            {formatDate}
          </Tooltip>
        );
      },
      width: handleWidth(!columnsVisible.taskCreatedDateShow, 175),
    },
    {
      title: "Highly Regulated?",
      dataIndex: "highRegulated",
      filters: mapFilter(convertedFilter(tableFilterDataNew.isHighRegulated)),
      filteredValue: filteredInfo.highRegulated || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (highRegulated) => (
        <Tooltip placement="topLeft" title={highRegulated}>
          {highRegulated}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.highRegulatedShow, 175),
    },
    {
      title: "Turnaround Time",
      dataIndex: "turnaroundTime",
      ellipsis: {
        showTitle: false,
      },
      render: (turnaroundTime) => (
        <Tooltip placement="topLeft" title={turnaroundTime}>
          {turnaroundTime}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.turnaroundTimeShow, 142),
    },
    {
      title: "Temporary Task",
      dataIndex: "temporaryTask",
      filters: mapFilter(convertedFilter(tableFilterDataNew.isTemporaryTask)),
      filteredValue: filteredInfo.temporaryTask || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (temporaryTask) => (
        <Tooltip placement="topLeft" title={temporaryTask}>
          {temporaryTask}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.temporaryTaskShow, 160),
    },
    {
      title: "Shared Task?",
      dataIndex: "isSharedTask",
      filters: mapFilter(convertedFilter(tableFilterDataNew.isSharedTask)),
      filteredValue: filteredInfo.isSharedTask || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (sharedTask) => (
        <Tooltip placement="topLeft" title={sharedTask}>
          {sharedTask}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.sharedTaskShow, 145),
    },
    {
      title: "Shared Task(s) ID",
      dataIndex: "sharedTaskIds",
      ellipsis: {
        showTitle: false,
      },
      filters: mapFilter(
        tableFilterDataNew.sharedTasks.map((i) => ({
          id: i.taskIds.join(","),
          name: i.sharedTaskIds,
        }))
      ),
      filteredValue: filteredInfo.sharedTaskIds || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      render: (sharedTaskIds) => (
        <Tooltip placement="topLeft" title={sharedTaskIds}>
          {sharedTaskIds}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.sharedTaskIdsShow, 220),
    },
    {
      title: "Shared Task(s) Name",
      dataIndex: "sharedTaskNames",
      ellipsis: {
        showTitle: false,
      },
      filters: mapFilter(
        tableFilterDataNew.sharedTasks.map((i) => ({
          id: i.taskIds.join(","),
          name: i.sharedTaskNames,
        }))
      ),
      filteredValue: filteredInfo.sharedTaskNames || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      render: (sharedTaskNames) => (
        <Tooltip placement="topLeft" title={sharedTaskNames}>
          {sharedTaskNames}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.sharedTaskNamesShow, 220),
    },
    {
      title: "Procedure Status",
      dataIndex: "procedureStatus",
      filters: mapFilter(tableFilterDataNew.procedureStatus),
      filteredValue: filteredInfo.procedureStatus || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (procedureStatus) => (
        <Tooltip placement="topLeft" title={procedureStatus}>
          {procedureStatus}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.procedureStatusShow, 170),
    },
    {
      title: "PMP Excluded",
      dataIndex: "pmpExcluded",
      filters: mapFilter(convertedFilter(tableFilterDataNew.isPmpExcluded)),
      filteredValue: filteredInfo.pmpExcluded || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        const isTaskActive = record.taskStatus === "Active";

        return (
          <div className={styles.pmpExcluded}>
            <Tooltip placement="topLeft" title={record.pmpExcluded}>
              {record.pmpExcluded}
            </Tooltip>
            {controlPmpExcludedEditShow(record) && (
              <PMPExcludedEditField
                isDisabled={!isTaskActive}
                procedureTaskId={record.procedureTaskId}
                procedureId={record.procedureId}
                procedureAccountId={record.procedureAccountID}
                uniqueKey={record.taskId}
                pmpExcluded={record.pmpExcluded}
                setProcedureIdToList={setProcedureListData}
                dataList={procedureListData}
                refreshProcedureList={refreshProcedureList}
              />
            )}
          </div>
        );
      },
      width: handleWidth(!columnsVisible.pmpExcludedShow, 150),
    },
    {
      title: "Procedure Saved In?",
      dataIndex: "procedureSaveInCategory",
      filters: mapFilter(tableFilterDataNew.procedureSaveInCategory),
      filteredValue: filteredInfo.procedureSaveInCategory || null,
      filterDropdown,
      onFilterDropdownOpenChange,
      ellipsis: {
        showTitle: false,
      },
      render: (procedureSaveInCategory) => (
        <Tooltip placement="topLeft" title={procedureSaveInCategory}>
          {procedureSaveInCategory}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.procedureSaveInCategoryShow, 220),
    },
    {
      title: "Procedure Path (Server)",
      dataIndex: "clientServerPath",
      ellipsis: {
        showTitle: false,
      },
      render: (clientServerPath) => (
        <Tooltip
          placement="left"
          title={clientServerPath}
          overlayClassName={styles.clientServerPathToolTip}
        >
          {clientServerPath}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.clientServerPathShow, 220),
    },
    {
      title: "Primary Procedure Owner",
      dataIndex: "primaryProcedureOwner",
      filters: mapFilter(tableFilterDataNew.primaryProcedureOwner),
      filteredValue: filteredInfo.primaryProcedureOwner || null,
      ellipsis: {
        showTitle: false,
      },
      className: columnsVisible.primaryProcedureOwnerShow ? "ppoColumn" : "",
      onFilterDropdownOpenChange,
      filterDropdown,
      render: (text, record) => {
        const isTaskActive = record.taskStatus === "Active";
        return (
          <div className="listSelect" key={record.procedureTaskId}>
            <AssignPPOSelect
              value={record.primaryProcedureOwner.trim()}
              primaryProcedureOwnerName={record.primaryProcedureOwnerName}
              showSearch={true}
              handleSubmitPPO={handleSubmitPPO}
              setProcedureListData={setProcedureListData}
              procedureListData={procedureListData}
              procedureTaskId={record.procedureTaskId}
              initDisabled={!record.ppoEditable || !isTaskActive}
              hoverMessage={record.ppoMessage}
              getPopupContainer={(triggerNode: any) => triggerNode.parentNode.parentNode}
            />
          </div>
        );
      },
      width: handleWidth(!columnsVisible.primaryProcedureOwnerShow, 220),
    },
    {
      title: "Procedure Owner",
      dataIndex: "procedureOwnerName",
      filters: mapFilter(tableFilterDataNew.procedureOwner),
      filteredValue: filteredInfo.procedureOwnerName || null,
      onFilterDropdownOpenChange,
      filterDropdown,
      ellipsis: {
        showTitle: false,
      },
      render: (procedureOwner) => (
        <Tooltip placement="topLeft" title={procedureOwner}>
          {procedureOwner}
        </Tooltip>
      ),
      width: handleWidth(!columnsVisible.procedureOwnerShow, 172),
    },
    {
      title: "Procedure Folder Create Date",
      dataIndex: "procedureFolderCreateTime",
      //@ts-ignore
      dbName: "ProcedureFolderCreateDate",
      sorter: true,
      sortOrder: handleTableSortOrder("ProcedureFolderCreateDate", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (procedureFolderCreateTime) => {
        const formatDate = formatAndCheckDate(procedureFolderCreateTime);
        return (
          <Tooltip placement="topLeft" title={formatDate}>
            {formatDate}
          </Tooltip>
        );
      },
      width: handleWidth(!columnsVisible.procedureFolderCreateDateShow, 248),
    },
    {
      title: "Last Updated Date",
      dataIndex: "lastUpdatedTime",
      //@ts-ignore
      dbName: "LastUpdatedDate",
      sorter: true,
      sortOrder: handleTableSortOrder("LastUpdatedDate", tableSortData),
      ellipsis: {
        showTitle: false,
      },
      render: (lastUpdatedTime) => {
        const formatDate = formatAndCheckDate(lastUpdatedTime);
        return (
          <Tooltip placement="topLeft" title={formatDate}>
            {formatDate}
          </Tooltip>
        );
      },
      width: handleWidth(!columnsVisible.lastUpdatedDateShow, 175),
    },
    {
      title: "Quick Access",
      key: "operation",
      fixed: "right",
      align: "center",
      width: 160,
      render: (text, record) => {
        const procedureDetailUrl = `/ProcedureDetail/${record.procedureTaskId}/${openSections.default}`;
        const updateProcedureDetailUrl = `/ProcedureDetail/${record.procedureTaskId}/${openSections.procedureFile}`;
        const changeHistory = `/ChangeHistory/${record.procedureTaskId}/${record.procedureId}`;
        const isTaskActive = record.taskStatus === "Active";
        return (
          <div className={styles.quickAccessDiv}>
            {isTaskActive && (
              <>
                <NormalToolTip
                  element={
                    <ListEditBtnIcon
                      href={procedureDetailUrl}
                      record={record}
                      testid={`enter-detail-${record.procedureId}`}
                    />
                  }
                  title="Enter Procedure Detail Page"
                />
                <NormalToolTip
                  element={
                    <img
                      alt=""
                      src={shareProcedureDetailEntry}
                      className={styles.shareProcedureDetailEntry}
                      onClick={() => handleShareClick(record)}
                      data-testid={`quick-access-share-${record.procedureId}`}
                    />
                  }
                  title="Share Document"
                />
                {record.procedureFolderStatus === "Active" ||
                record.procedureFolderStatus === "Updating" ? (
                  <ListUpdateBtnIcon
                    href={updateProcedureDetailUrl}
                    record={record}
                    setLoading={setLoading}
                    testid={`update-procedure-${record.procedureId}`}
                  />
                ) : (
                  <NormalToolTip
                    element={
                      <img
                        alt=""
                        src={editProcedureDetailDisable}
                        className={styles.editProcedureDetailDisable}
                        data-testid={`update-procedure-disabled-${record.procedureId}`}
                      />
                    }
                    title="Update Procedure"
                  />
                )}
                <NormalToolTip
                  element={
                    <img
                      alt=""
                      src={downloadProcedureDetailEntry}
                      className={styles.downloadProcedureDetailEntry}
                      onClick={() => handleDownloadClick(record)}
                      data-testid={`quick-access-download-${record.procedureId}`}
                    />
                  }
                  title="Download Document"
                />
              </>
            )}
            <NormalToolTip
              element={
                <a
                  href={changeHistory}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`quick-access-change-history-${record.procedureId}`}
                >
                  <img alt="" src={changeHistoryEntry} className={styles.changeHistoryEntry} />
                </a>
              }
              title="View Change History"
            />
          </div>
        );
      },
    },
  ];

  return columns;
}
